import IconButton from '@mui/material/IconButton';
import { toastr } from 'react-redux-toastr';
import Modal from '@material-ui/core/Modal';
import { Button } from '@mui/material';
import API from '../../../../create/api';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

interface ReturnedToMerchantProps {
  id: number;
  returnToMerchant: boolean;
  updateParcel: (id: number, data: object) => void;
}

export default function ReturnedToMerchant({ id, returnToMerchant, updateParcel }: ReturnedToMerchantProps) {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = React.useState(false);

  async function Action() {
    setModalOpen(false);
    await API.update(`${process.env.REACT_APP_API_SERVER}/parcels`, id, { returnToMerchant: true }).then((res) => {
      toastr.success('Parcel Updated', `Parcel ID:${id} Set to Return to Merchant`);
      updateParcel(id, { returnToMerchant: true });
    });
  }

  function handleClose() {
    setModalOpen(false);
  }

  return (
    <>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={modalOpen}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className={classes.paper}>
          <h1 id="spring-modal-title">Return to Merchant</h1>
          <p id="spring-modal-description">
            Do you want to Return to Merchant {id}
            <br />
            <Button color="secondary" onClick={Action}>
              Yes
            </Button>
            <Button color="primary" onClick={handleClose}>
              No
            </Button>
          </p>
        </div>
      </Modal>
      <IconButton
        disabled={returnToMerchant}
        onClick={() => {
          setModalOpen(true);
        }}
      >
        <ArrowOutwardIcon
          fontSize="small"
          style={{ color: `${returnToMerchant ? 'rgb(225 67 67 / 81%)' : '#2e7d32'}` }}
        />
      </IconButton>
    </>
  );
}
